import { createSlice } from '@reduxjs/toolkit';
import { AddUpdateInvoice, getAllInvoices, getByInvoiceId, getInvoicesByStatusAsync, UpdateInvoiceStatusAsync } from './invoiceThunk';
import { APIStatus } from '@application/common/enums/api-status';
const initialState = {
    status: APIStatus.IDLE,
    invoices: []
};
export const invoiceSlice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllInvoices.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInvoices.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.invoices = action.payload;
        })
            .addCase(getAllInvoices.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getInvoicesByStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInvoicesByStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.invoicesWithStatus = action.payload;
        })
            .addCase(getInvoicesByStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(AddUpdateInvoice.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(AddUpdateInvoice.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.addUpdateInvoice = action.payload;
        })
            .addCase(AddUpdateInvoice.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(UpdateInvoiceStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(UpdateInvoiceStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.singleInvoice = action.payload;
        })
            .addCase(UpdateInvoiceStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getByInvoiceId.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getByInvoiceId.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.singleInvoice = action.payload;
        })
            .addCase(getByInvoiceId.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default invoiceSlice.reducer;
